import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { showError, showSuccess } from '../utils/alerts';
import { API_BASE_URL } from '../config';

const CargaImagen = ({ id_company, token }) => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [tiposGasto, setTiposGasto] = useState([]);
    const [tipoGastoSeleccionado, setTipoGastoSeleccionado] = useState('');

     // Función para cargar los tipos de gasto desde la API
    useEffect(() => {
      const obtenerTiposGasto = async () => {
          try {
            const response = await axios.get(`${API_BASE_URL}/api/tipos-gasto`, {
                headers: {
                      Authorization: `Bearer ${token}`
                  }
              });
              setTiposGasto(response.data); // Asignar los tipos de gasto obtenidos a la variable de estado
          } 
          catch (error) {
              console.error("Error al obtener los tipos de gasto:", error);
          }
      };
      obtenerTiposGasto();
      }, [token]);
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };
    const handleTipoGastoChange = (e) => {
      setTipoGastoSeleccionado(e.target.value);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file|| !tipoGastoSeleccionado) {
            showError('Por favor, selecciona un archivo y un tipo de gasto');
            return;
        }
        const formData = new FormData();
        formData.append('file', file); // Imagen cargada
        formData.append('id_company', id_company); // ID de la empresa
        formData.append('categoria_gasto', tipoGastoSeleccionado); // Tipo de gasto seleccionado
        try {
            setLoading(true);
            await axios.post(`${API_BASE_URL}/api/extraer-datos`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            showSuccess('Datos extraídos y guardados correctamente');
            setFile(null); // Limpiar el archivo seleccionado
        } catch (error) {
            console.error('Error al cargar el archivo y extraer datos:', error);
            showError(error.response?.data?.error || 'Error al extraer y guardar los datos');
        } finally {
            setLoading(false);
        }
    };
    return (
        <div>
            <h1>Cargar Imagen</h1>
            <form onSubmit={handleSubmit}>
                <input
                    type="file"
                    onChange={handleFileChange}
                    accept="image/*"
                />
                <select value={tipoGastoSeleccionado} onChange={handleTipoGastoChange}>
                    <option value="">Selecciona un tipo de gasto</option>
                    {tiposGasto.map((tipo) => (
                        <option key={tipo.id_tipo_gasto} value={tipo.id_tipo_gasto}>
                            {tipo.nombre_gasto}
                        </option>
                    ))}
                </select>


                <button type="submit" disabled={loading}>
                    {loading ? "Procesando..." : "Cargar Imagen y Extraer Datos"}
                </button>
            </form>
        </div>
    );
};

export default CargaImagen;
